/* eslint-disable */
export enum TripOptimizingMethod {
  GOOGLE_DIRECTIONS = 'GOOGLE_DIRECTIONS',
  GOOGLE_OPTIMIZER = 'GOOGLE_OPTIMIZER',
  NONE = 'NONE',
}
